import { collectionEngineV1 } from '../apis.js';
const req = collectionEngineV1('/query');
export const query = (base) => (q) => {
    return req('POST', '', {
        body: q,
    });
};
//# sourceMappingURL=query.js.map